import { AutoShipment, Category, MappedItem, RefItem, UpcomingShipment, UpcomingShipments } from "../types"

const getItemCategories = () => {
  const entries: [Category, MappedItem][] = [
    ['AIRDIS', { image: 'waterline', name: 'Air Disinfection' }],
    ['Amalgam', { image: 'amalgam', name: 'Waste Management' }],
    ['Lead Waste', { image: 'lead-waste', name: 'Waste Management' }],
    ['Pharma', { image: 'pharma', name: 'Waste Management' }],
    ['Sharps-RMW', { image: 'sharps', name: 'Waste Management' }],
    ['SPORE TEST', { image: 'biological', name: 'Biological Monitoring' }],
    ['WATERLINE', { image: 'waterline', name: 'Waterline Management' }],
  ]

  const mapped = new Map<Category, MappedItem>(entries)

  return mapped
}

export const getPeriodIds = (upcomingShipments: UpcomingShipments, autoShipments: AutoShipment[]) => {
  const upcomingPeriods = Object.keys(upcomingShipments).map(period => Number(period))
  const autoShipmentsPeriods = autoShipments.map(shipment => shipment.refillPeriodID)

  const uniquePeriods = new Set([...upcomingPeriods, ...autoShipmentsPeriods])
  const periodIds = Array.from(uniquePeriods)

  return periodIds
}

const getReferenceItems = (refItems: RefItem[]) => {
  const entries = refItems.map(refItem => {
    const itemNumber = refItem.item_number
    const entry: [string, RefItem] = [itemNumber, refItem]
    
    return entry 
  })

  const referenceItems = new Map<string, RefItem>(entries)

  return referenceItems
}

const getAutoshipItem = (autoShipment: AutoShipment, referenceItems: Map<string, RefItem>) => {
  const autoShipItem = structuredClone(autoShipment)
  
  const itemNumber = autoShipItem.itemId
  const referenceItem = referenceItems.get(itemNumber)

  autoShipItem.image = referenceItem?.images ?? null
  autoShipItem.item_number = itemNumber

  return autoShipItem
}

const getReferenceCategory = (autoShipment: AutoShipment, referenceItems: Map<string, RefItem>) => {
  const itemNumber = autoShipment.itemId
  const referenceItem = referenceItems.get(itemNumber)
  const referenceCategory = referenceItem && referenceItem.category as Category

  return referenceCategory
}

const getSubscriptionName = (autoShipment: AutoShipment, referenceItems: Map<string, RefItem>) => {
  const itemCategories = getItemCategories()

  const referenceCategory = getReferenceCategory(autoShipment, referenceItems)
  const itemCategory = referenceCategory && itemCategories.get(referenceCategory)

  let displayName = ''

  if (itemCategory) {
    displayName = itemCategory.name
  } else if (referenceCategory) {
    displayName = referenceCategory
  }

  return displayName
}

const getSubscriptionImage = (autoShipment: AutoShipment, referenceItems: Map<string, RefItem>) => {
  const itemCategories = getItemCategories()

  const referenceCategory = getReferenceCategory(autoShipment, referenceItems)
  const itemCategory = referenceCategory && itemCategories.get(referenceCategory)

  const kitImage = itemCategory?.image ?? ''

  return kitImage
}

export const getSubscriptions = (autoShipments: AutoShipment[], refItems: RefItem[] | null) => {
  const subscriptions = new Map<number, Partial<UpcomingShipment>>()

  if (autoShipments && refItems) {
    const referenceItems = getReferenceItems(refItems)

    autoShipments.forEach(shipment => {
      const autoShipItem = getAutoshipItem(shipment, referenceItems)

      const refillPeriodId = shipment.refillPeriodID
      const container = subscriptions.get(refillPeriodId)

      if (container) {
        container.items?.push(autoShipItem)
      } else {
        const periodName = shipment.refillPeriodName

        const kitImage = getSubscriptionImage(shipment, referenceItems)
        const displayName = getSubscriptionName(shipment, referenceItems)

        const productContainer: Partial<UpcomingShipment> = {
          type: 'subscription',
          items: [autoShipItem],
          refill_period_name: periodName,
          kit_image: kitImage,
          displayName,
        }

        subscriptions.set(refillPeriodId, productContainer)
      }
    })
  }

  return subscriptions
}
